import React, { useMemo, useState } from "react";
import { Box, Paper, Stack, Tab, Tabs, Typography } from "@mui/material";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";

import DashboardSummaryStrip from "../../../../../components/Dashboard/DashboardSummaryStrip";
import Contractors from "../../Contractors";
import { isContractorApproved, isContractorReviewPending } from "../../../../../libs/contractorReview";

const PeopleSection = ({
  busyById,
  contractorProfilesByUid,
  contractors = [],
  formatCurrency,
  loading,
  onReviewContractor,
}) => {
  const [activeTab, setActiveTab] = useState("review_gate");

  const pendingContractors = useMemo(
    () => contractors.filter(isContractorReviewPending),
    [contractors]
  );
  const approvedContractors = useMemo(
    () => contractors.filter(isContractorApproved),
    [contractors]
  );

  const summaryItems = useMemo(
    () => [
      {
        label: "Pending reviews",
        value: pendingContractors.length,
        helper: "Awaiting approval decision",
      },
      {
        label: "Approved",
        value: approvedContractors.length,
        helper: "Visible for matching",
      },
      {
        label: "Total contractors",
        value: contractors.length,
        helper: "All contractor accounts",
      },
    ],
    [approvedContractors.length, contractors.length, pendingContractors.length]
  );

  const visibleContractors = activeTab === "review_gate" ? pendingContractors : approvedContractors;

  return (
    <Stack spacing={2}>
      <Stack spacing={0.5}>
        <Typography variant="h5" sx={{ fontWeight: 850 }}>
          People
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Review contractor onboarding submissions and keep the talent directory organized.
        </Typography>
      </Stack>

      <DashboardSummaryStrip items={summaryItems} />

      <Paper variant="outlined" sx={{ borderColor: "#dadce0", borderRadius: 2, overflow: "hidden" }}>
        <Tabs
          value={activeTab}
          onChange={(_event, nextTab) => setActiveTab(nextTab)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 56,
            borderBottom: "1px solid #edf0f3",
            "& .MuiTab-root": {
              minHeight: 56,
              fontWeight: 800,
              textTransform: "none",
            },
          }}
        >
          <Tab
            value="review_gate"
            icon={<EngineeringOutlinedIcon fontSize="small" />}
            iconPosition="start"
            label="Pending request"
          />
          <Tab
            value="directory"
            icon={<GroupsOutlinedIcon fontSize="small" />}
            iconPosition="start"
            label="Directory"
          />
        </Tabs>

        <Box sx={{ p: { xs: 1.5, md: 2 } }}>
          <Contractors
            loading={loading}
            contractors={visibleContractors}
            formatCurrency={formatCurrency}
            contractorProfilesByUid={contractorProfilesByUid}
            busyById={busyById}
            onReviewContractor={onReviewContractor}
            title={activeTab === "review_gate" ? "Contractor review" : "Contractor directory"}
            description={
              activeTab === "review_gate"
                ? ""
                : ""
            }
            showPendingChip={activeTab === "review_gate"}
            reviewEnabled={activeTab === "review_gate"}
          />
        </Box>
      </Paper>
    </Stack>
  );
};

export default PeopleSection;
